import React from "react";
import styled, { css } from "styled-components";

const Button = styled.button`
  font-size: 14px;
  text-transform: none;
  margin-top: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  background: transparent;
  border: 1px solid;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ variant }) => {
    switch (variant) {
      case "offer":
        return css`
          border-color: #22c55e;
          color: #22c55e;

          &:hover:not(:disabled) {
            background: rgba(34, 197, 94, 0.1);
            border-color: #16a34a;
            color: #16a34a;
          }
        `;
      case "chat":
        return css`
          border-color: #5ce9ff;
          color: #5ce9ff;

          &:hover:not(:disabled) {
            background: rgba(92, 233, 255, 0.1);
            border-color: #00d4ff;
            color: #00d4ff;
          }
        `;
      case "primary":
        return css`
          border-color: #00f7d2;
          color: #00f7d2;

          &:hover:not(:disabled) {
            background: rgba(0, 247, 210, 0.1);
            border-color: #00d4b8;
            color: #00d4b8;
          }
        `;
      case "danger":
        return css`
          border-color: #ef4444;
          color: #ef4444;

          &:hover:not(:disabled) {
            background: rgba(239, 68, 68, 0.1);
            border-color: #dc2626;
            color: #dc2626;
          }
        `;
      default:
        return css`
          border-color: #1f2937;
          color: #e5e7eb;

          &:hover:not(:disabled) {
            background: rgba(255, 255, 255, 0.05);
            border-color: #374151;
          }
        `;
    }
  }}
`;

const ProductButton = ({ 
  variant = "default", 
  children, 
  icon, 
  onClick, 
  disabled,
  type = "button",
  ...props 
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...props}
    >
      {children}
      {icon && <i className={icon} aria-hidden="true" />}
    </Button>
  );
};

export default ProductButton;
